module.exports = __webpack_public_path__ + "static/img/lgchem-history.160790a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/lgchem-history.jpg
// module id = su6E
// module chunks = 0